import { Component, OnInit, inject } from '@angular/core';
import { HomeService } from 'src/app/source/features/home/services/home.service';
import { NavBarItem } from '../nav-bar/nav-bar.interface';



@Component({
  selector: 'app-footer-desktop',
  templateUrl: './footer-desktop.component.html',
  styleUrls: ['./footer-desktop.component.scss']
})
export class FooterDesktopComponent implements OnInit {
  private homeService = inject(HomeService);

  public rrss: NavBarItem[] = [];
  public legalFooterItems: NavBarItem[] = [];


  ngOnInit(): void {
    this.getFooterItems();
  }


  getFooterItems(): void {
    this.homeService.getNavbarData().subscribe({
      next: (dataMenu) => {
        this.rrss = dataMenu.rrss;
        this.legalFooterItems = dataMenu.legal;
      },
      error: (err) => {
        console.error('Error en getFooterItems:', err);
      }
    });
  }
}
